import React from 'react';
import { withStyles } from '@material-ui/styles';
import { Grid, Button, TextField, Card, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

import { HORIZONTAL_LOGO as theLogo } from '../../constants';
import { async } from 'validate.js';
import apiManager from '../../ApiManager';

const styles = (theme => ({
    root: {
        paddingLeft: 32,
        paddingTop: 18,
        '@media (max-width: 400)': {
            // marginLeft: 0,
        },      
    },
    searchbar: {
        // marginLeft: 72,
        // '@media (min-width: 1264px)': {
        //     marginLeft: 0,
        // },
    },
    cardtitle: {
        fontWeight: 500,
        fontSize: 24,
        color: '#555',
        marginBottom: 32,
    },
    number: {
        fontSize: 18,
        color: 'black',
        border: '1px solid #557',
        borderRadius: '50%',
        textAlign: 'center',
        height: 36,
        width: 36,
        paddingTop: 7,
        display: 'inline-block',
        marginRight: 12,
        backgroundColor: '#eee',
        boxShadow: '1px 1px 6px #888888'
    },
    sectiontitle: {
        fontWeight: 500,
        fontSize: 16,
        display: 'inline-block',
    },
    explain: {
        margin: 18,
        marginLeft: 48,
        fontStyle: 'italic',
        width: '80%'
    },
    target: {
        border: '1px solid #333',
        borderRadius: 5,
        minHeight: 200,
        padding: 12,
        margin: 12,
        marginLeft: 48,
    },
    namebox: {
        margin:12,
        marginLeft: 48,
    },
    mainCTA: {
        marginTop: 24,
        float: 'right',
    },
    narrtitle: {
        marginTop: 12,
        color: '#333',
        fontSize: 16,
    },
    et_pb_portfolio_item: {
        boxShadow: '6px 6px 18px 0px rgba(0,0,0,0.3)'
    },
    et_portfolio_image: {
        boxShadow: '6px 6px 18px 0px rgba(0,0,0,0.3)'
    },
    createcard: {
        padding: 32,
        marginRight: 12,
        width: '90%'
    },
    porfoliocard: {
        marginBottom: 24,
        padding: 12,
    }
}));


export class HomeVisitor extends React.PureComponent {
    constructor(...args) {
        super(...args);
        this._logoutTimerID = null;
        this._logoutIntervalID = null;

        const { user, apiManager, history } = this.props;

        this.state = {
            user,
            apiManager,
            history,
            search: '',
            newName: '',
            myActivVideos: [],
        }

    }

    componentDidMount = () => {
        this.getSystemSettings();
    }

    getSystemSettings = async() => {
        const settings = await apiManager.getSystemSettings();
    }

    handleNameInput = event => {
        event.persist();

        this.setState({newName: event.target.value } );
    }
     render() {
        const { classes } = this.props;
          return (
            <div className={classes.root}>
                { /* searchbar */}
                <table className='wideFull'>
                    <tr>
                        <td style={{width: 180}}>
                        <img src={theLogo} alt="Narrasys.com"  className='am-logo'  />
                        </td>
                        <td style={{width: 240}}>
                        <Button
                                color="primary"
                                size="small"
                                type="submit"
                                variant="contained"
                                // onClick={this.createClick}
                            >
                                Create Now
                            </Button>  
                        </td>
                        <td>
                        <TextField size='small'
                                className={classes.textField}
                                fullWidth
                                label="Search ActivVideos"
                                name="search"
                                value={this.state.search}
                                // onChange={this.handleChange}
                                type=""
                                variant="outlined"
                            />
                        </td>
                        <td className='fl-right' style={{width: 240}}>
                        <Button href="/signup" color="default">New Account</Button>
                            <Button href="/signin"color="default">Sign In</Button>
                        </td>
                    </tr>
                </table>
                

                { /* marketing */ }
                <div className='am-marquee'>
                <Typography
                                className={classes.title}
                                // variant="h6"
                                align="center"
                            >
                           <img src={theLogo} alt="Narrasys.com" width="200px" align='middle' /><br />
                    AUGMENTED MEDIA IN MOMENTS
                    <br /><br />
   <p>
   I have a 10 year old son. He has words. He is so good with these words it's unbelievable. You could see there was text coming out of her eyes, text coming out of her wherever. Some people have an ability to write placeholder text... It's an art you're basically born with. You either have it or you don't. An ‘extremely credible source’ has called my office and told me that Barack Obama’s placeholder text is a fraud.
</p>
<br/><br />
<p>
Some people have an ability to write placeholder text... It's an art you're basically born with. You either have it or you don't.
   </p>
   <br/><br />
   - Guess who

                  </Typography>
                </div>

                 { /* content */}
                <Grid
                    container
                    spacing={4}
                    style={{marginTop: 48, marginLeft: 4}}>
                  <Grid item sm={12} md={7}>
                      <div className={classes.cardtitle}>Create Your Next ActivVideo</div>
                      <Card className={classes.createcard}>
                      <div className={classes.createsection}>
                          <div className={classes.number}>1</div>
                          <div className={classes.sectiontitle}>Select Video to Upload</div>
                          <div className={classes.explain}>Drag and drop or select an mp4 video</div>
                          <div className={classes.target}></div>
                      </div>
                      <div className={classes.createsection}>
                          <div className={classes.number}>2</div>
                          <div className={classes.sectiontitle}>Optional: Select Transcript to Upload</div>
                          <div className={classes.explain}>Drag and drop or select an VTT file.  
                            <a>What's a VTT file? </a> Note that a transcript file helps viewers follow along, make notes, and search through your augmented media.  
                          </div>
                          <div className={classes.target}></div>
                      </div>
                      <div className={classes.createsection}>
                          <div className={classes.number}>3</div>
                          <div className={classes.sectiontitle}>Name Your ActivVideo: </div>
                          <div className={classes.namebox}>
                              <TextField
                                fullWidth
                                label="ActivVideo Name"
                                name="newname"
                                onChange={this.handleNameInput}
                                type="text"
                                value={this.state.newName}
                                variant="outlined"
                            />
                        </div>
                      </div>
                      <div className={classes.namebox}>
                      <Button variant="contained" color="primary" className={classes.mainCTA}>Create This ActivVideo</Button>
                      </div>
                      </Card>
                      </Grid>
                      <Grid item sm={12} md={3}>

                          <div className={classes.cardtitle}>Recent ActivVideos</div>
                          {/* {this.state.myActivVideos.length === 0
                              ? <div className={classes.explain}>You don't have any ActivVideos yet.  Your first five are free, so create your first one today.</div>
                              : <div></div>
                          }
                          <hr style={{ border: '1px solid #dddddd88', margin: 32 }} /> */}
                          <div className={classes.cardtitle}><i>Inspiration:</i></div>
                          {/* portfolio item */}
                          <Card className={classes.porfoliocard}>
                          <div id="post-2996" class="et_pb_portfolio_item et_pb_grid_item project_category_marcom et_pb_filterable_portfolio_item_0_21 post-2996 project type-project status-publish has-post-thumbnail hentry project_category-marcom active" style={{ display: 'block', marginBottom: 32 }}>
                              <a target='_blank' href="https://narrasys.com/project/personal-and-professional-branding-james-citrin-professional-profile/">
                                  <span className={classes.et_portfolio_image}>
                                      <img src="https://t4tlh27qhwv3yoump20cwrd5-wpengine.netdna-ssl.com/wp-content/uploads/2017/08/TCPi_Jim_Profile_Gallery-400x284.jpg" alt="Personal and Professional Branding: James Citrin Professional Profile" class="" srcset="https://narrasys.com/wp-content/uploads/2017/08/TCPi_Jim_Profile_Gallery.jpg 479w, https://narrasys.com/wp-content/uploads/2017/08/TCPi_Jim_Profile_Gallery-400x284.jpg 480w " sizes="(max-width:479px) 479px, 100vw " width="300" height="213" />
                                      <span class="et_overlay et_pb_inline_icon" data-icon="I"></span>
                                  </span>
                              </a>
                              <div className={classes.narrtitle}><a target='_blank' href="https://narrasys.com/project/personal-and-professional-branding-james-citrin-professional-profile/">Personal and Professional Branding: James Citrin Professional Profile</a></div>
                          </div>
                          </Card>
                          <Card className={classes.porfoliocard}>
                          <div id="post-2996" class="et_pb_portfolio_item et_pb_grid_item project_category_marcom et_pb_filterable_portfolio_item_0_21 post-2996 project type-project status-publish has-post-thumbnail hentry project_category-marcom active" style={{ display: 'block', marginBottom: 32 }}>
                              <a target='_blank' href="https://narrasys.com/project/northwestern-university-kellogg-trust/">
                                  <span className={classes.et_portfolio_image}>
                                      <img src="https://t4tlh27qhwv3yoump20cwrd5-wpengine.netdna-ssl.com/wp-content/uploads/2017/08/Kellogg_Trsut_Project_Gallery-400x284.jpg" alt="Content Marketing: Kellogg Northwestern Trust Project" class="" srcset="https://narrasys.com/wp-content/uploads/2017/08/Kellogg_Trsut_Project_Gallery.jpg 479w, https://narrasys.com/wp-content/uploads/2017/08/Kellogg_Trsut_Project_Gallery-400x284.jpg 480w " sizes="(max-width:479px) 479px, 100vw " width="300" height="213" />
                                      <span class="et_overlay et_pb_inline_icon" data-icon="I"></span>
                                  </span>
                              </a>
                              <div className={classes.narrtitle}><a target='_blank' href="https://narrasys.com/project/northwestern-university-kellogg-trust/">Content Marketing: Kellogg Northwestern Trust Project</a></div>
                          </div>
                          </Card>

                  </Grid>
                </Grid>
            </div>
        );
    }
};

HomeVisitor.propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object,
    apiManager: PropTypes.object
};

export default withStyles(styles)(HomeVisitor);
